var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExclusive = function SvgExclusive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19295_38403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.539062C3.13129 0.539062 0 3.66982 0 7.53906C0 11.4078 3.13075 14.5391 7 14.5391C10.8687 14.5391 14 11.4083 14 7.53906C14 3.67035 10.8692 0.539062 7 0.539062ZM7 13.4453C3.73573 13.4453 1.09375 10.8036 1.09375 7.53906C1.09375 4.2748 3.73541 1.63281 7 1.63281C10.2643 1.63281 12.9062 4.27448 12.9062 7.53906C12.9062 10.8033 10.2646 13.4453 7 13.4453ZM8.62236 10.7656C8.62236 11.0677 8.37755 11.3125 8.07549 11.3125H5.92451C5.62245 11.3125 5.37764 11.0677 5.37764 10.7656C5.37764 10.4636 5.62245 10.2188 5.92451 10.2188H6.45312V7.01045H5.92451C5.62245 7.01045 5.37764 6.76564 5.37764 6.46358C5.37764 6.16151 5.62245 5.9167 5.92451 5.9167H7C7.30206 5.9167 7.54688 6.16151 7.54688 6.46358V10.2188H8.07549C8.37755 10.2188 8.62236 10.4636 8.62236 10.7656ZM6.31641 3.92061C6.31641 3.54303 6.62242 3.23701 7 3.23701C7.37758 3.23701 7.68359 3.54303 7.68359 3.92061C7.68359 4.29808 7.37758 4.6042 7 4.6042C6.62242 4.6042 6.31641 4.29808 6.31641 3.92061Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19295_38403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.539062)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclusive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclusive.2154abf6.svg";
export { ForwardRef as ReactComponent };